.LevelMeter {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
}

.LevelMeter__column {
    display: flex;
    flex-direction: column-reverse;
    gap: 4px;
    padding: 10px 12px;
    border-radius: 10px;
    background: var(--soniq-t--global--background--color--surface--panel-subtle);
    border: 1px solid var(--soniq-t--global--border--color--input--default);
}

.LevelMeter__segment {
    width: 30px;
    height: 8px;
    border-radius: 2px;
    background: var(--soniq-t--global--background--color--status--muted--default);
    border: 1px solid var(--soniq-t--global--border--color--status--muted--default);
    transition: background 60ms linear, box-shadow 60ms linear;

    &.isLit {
        background: var(--soniq-t--global--palette--neon-green);
        border-color: var(--soniq-t--global--border--color--status--success--default);
        box-shadow: 0 0 8px 1px var(--soniq-t--global--background--color--status--success--default);
    }

    &.isHot.isLit {
        background: var(--soniq-t--global--palette--yellow);
        border-color: var(--soniq-t--global--border--color--status--warning--default);
        box-shadow: 0 0 8px 1px var(--soniq-t--global--background--color--status--warning--default);
    }

    &.isClip.isLit {
        background: var(--soniq-t--global--palette--hot-pink);
        border-color: var(--soniq-t--global--border--color--status--danger--default);
        box-shadow: 0 0 8px 1px var(--soniq-t--global--background--color--status--danger--default);
    }
}

.LevelMeter__label {
    font-family: var(--soniq-t--global--font--family--mono);
    font-size: var(--soniq-t--global--font--size--field-label);
    letter-spacing: var(--soniq-t--global--font--letter-spacing--wide);
    text-transform: uppercase;
    color: var(--soniq-t--global--text--color--label--default);
}

@media (prefers-reduced-motion: reduce) {
    .LevelMeter__segment {
        transition: none;
    }
}
